import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, type IIconsVector } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { PresetCard, PresetGrid } from 'shared/Preset'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { NumbersPath } from 'pages/settings/pages/numbers/route/numbersPath'
import styles from './styles.module.scss'

type IAddNumberOption = {
  key: string
  icon: IIconsVector
  title: string
  subtitle: string
  path?: string
  id?: string
}

export const AddNumber = observer(() => {
  const entities = useEntitiesContext()
  const { uk_compliance } = entities.featureFlagsStore
  const [selectedKey, setSelectedKey] = useState('buy')

  const addNumberOptions: IAddNumberOption[] = [
    {
      key: 'buy',
      icon: 'shoppingCart',
      path: `/${NumbersPath.buyNumber.stepsRoot}`,
      title: 'Buy a number',
      subtitle: uk_compliance
        ? 'Get a local, toll-free or international number'
        : 'Get a local or toll-free number',
    },
    {
      key: 'app',
      icon: 'plug',
      path: `/${NumbersPath.addNumberFromApp.stepsRoot}`,
      title: 'Add a number from an app',
      subtitle: 'Connect a number from calling apps (Aircall, RingCentral, etc.)',
    },
    {
      key: 'landline',
      icon: 'phone',
      path: `/${NumbersPath.textEnableLandline.stepsRoot}`,
      title: 'Text-enable a landline',
      subtitle: 'Send and receive text messages with your landline',
    },
    {
      key: 'port',
      icon: 'arrowRight',
      title: 'Port your number',
      subtitle: 'Move your number to Salesmsg for both texting and calling',
      id: 'dropdownItem_portNumbers',
    },
  ]

  const handleNext = () => {
    const selected = addNumberOptions.find((option) => option.key === selectedKey)
    if (selected?.path) {
      uiStore.changeRouteViaVue({ path: selected.path })
      return
    }
    if (selected?.id) {
      document.getElementById(selected.id)?.click()
    }
  }

  return (
    <div className={styles.content}>
      <PresetGrid columns={2} className={styles.grid}>
        {addNumberOptions.map((item) => (
          <PresetCard
            key={item.key}
            id={item.id}
            icon={item.icon}
            name={item.title}
            description={item.subtitle}
            selected={selectedKey === item.key}
            onClick={() => setSelectedKey(item.key)}
          />
        ))}
      </PresetGrid>
      <Button typeBtn='contained' size='medium' text='Next' fullWidth onClick={handleNext} />
    </div>
  )
})
